import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getStatistics () {
    return ApiService.get('purchasing/dashboard/statistics')
  }
}

export default DashboardService
